module.exports = __webpack_public_path__ + "dc3834094eb9d53d374931f7556a5724.png";